import { useMutation, useQueryClient } from '@tanstack/react-query';
import { App } from 'antd';

import { setAccountCPFOptions } from '@lib/api/options/accounts';
import { getAccountOptions } from '@lib/api/options/auth';
import { MutationCallbackOptions } from '@lib/api/options/types';
import AppError from '@lib/app-error';

export const useSetAccountCPF = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();
  const { mutateAsync: setCPF, isPending } = useMutation(
    setAccountCPFOptions(),
  );

  const onSetCPF = (
    cpf: string,
    options?: MutationCallbackOptions<Awaited<ReturnType<typeof setCPF>>>,
  ) =>
    setCPF(
      { payload: cpf },
      {
        onSuccess: (account) => {
          queryClient.setQueryData(getAccountOptions().queryKey, account);
          message.success('CPF cadastrado com sucesso.');
          options?.onCompleted?.(account);
        },
        onError: (error) => {
          if (error instanceof AppError && error.code === 'cpf-in-use') {
            message.error('O CPF informado já está em uso.');
          } else {
            message.error('Não foi possível cadastrar o CPF. Tente novamente.');
          }
          options?.onError?.(error);
        },
      },
    );

  return { onSetCPF, savingCPF: isPending };
};
